import { helper } from '@ember/component/helper';

export default helper(function boolHelper(params, { string }) {
  const bool = params.every(p => p);
  return string ? (bool ? 'true' : 'false') : bool;
});
